import actionTypes from 'Redux/constants';

const historyInitialState = {
  currentRecord: null,
  reviewHistory: null,
  fetchingHistory: false,
  showCategoryNotification: false,
};

export const historyReducer = (state = historyInitialState, action) => {
  switch (action.type) {
    case actionTypes.history.setCurrentRecord:
      return {
        ...state,
        currentRecord: action.payload,
      };

    case actionTypes.history.setReviewHistory:
      return {
        ...state,
        reviewHistory: action.payload,
      };
    default:
      return state;
  }
};
